import { render, staticRenderFns } from "./DataEditor.vue?vue&type=template&id=791abff4"
import script from "./DataEditor.vue?vue&type=script&lang=js"
export * from "./DataEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports